"use strict";
import { useMemo } from "react";
import { useDataChannel, useLoosePermissionChecker } from "../../../hooks";
export function useMenuItems() {
  const checkLoosePermissions = useLoosePermissionChecker();
  const items = useDataChannel(null, "app-navigation");
  return useMemo(() => items.filter((item) => {
    const { data } = item;
    const { permissions } = data;
    if (permissions) return checkLoosePermissions(permissions);
    return true;
  }), [items, checkLoosePermissions]);
}
